import React from "react";
import {
  FaArrowLeft,
  FaEllipsisV,
  FaPhone,
  FaVideo,
  FaHome,
  FaBox,
  FaPaperPlane,
  FaPaperclip,
} from "react-icons/fa";
import translations from "../../translation"; // Import translations

const WhatsappScreen = ({ content, title, name, attachment, language }) => {
  const translate = (key) => translations[language][key] || key; // Translation function

  // Function to detect the text direction
  const detectDirection = (text) => {
    const rtlRegex = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/; // Detect RTL characters
    return rtlRegex.test(text) ? "rtl" : "ltr";
  };

  const direction = detectDirection(content || ""); // Detect direction from the content

  return (
    <div
      className="whatsapp-screen bg-light"
      style={{
        maxWidth: "400px",
        margin: "0 auto",
        border: "1px solid #ddd",
        fontFamily: "'Roboto', sans-serif",
        borderRadius: "10px",
      }}
    >
      {/* Header */}
      <div
        className="whatsapp-header d-flex align-items-center justify-content-between"
        style={{
          backgroundColor: "#075E54",
          padding: "10px",
          color: "#fff",
          borderRadius: "10px 10px 0px 0px",
        }}
      >
        <div className="d-flex align-items-center">
          <FaArrowLeft style={{ fontSize: "18px", cursor: "pointer" }} />
          <div style={{ marginLeft: "10px" }}>
            <h5
              style={{
                margin: 0,
                fontSize: "14px",
                fontWeight: "bold",
                textTransform: "capitalize",
                direction, // Apply detected direction
                textAlign: direction === "rtl" ? "right" : "left",
              }}
            >
              {title || translate("defaultTitle")}
            </h5>
            <p
              style={{
                margin: 0,
                fontSize: "12px",
                color: "#eee",
                textTransform: "capitalize",
                direction, // Apply detected direction
                textAlign: direction === "rtl" ? "right" : "left",
              }}
            >
              {name || translate("defaultName")}
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <FaVideo style={{ fontSize: "18px", margin: "0 10px", cursor: "pointer" }} />
          <FaPhone style={{ fontSize: "16px", margin: "0 10px", cursor: "pointer" }} />
          <FaEllipsisV style={{ fontSize: "18px", cursor: "pointer" }} />
        </div>
      </div>

      {/* Message Bubble */}
      <div
        className="whatsapp-body"
        style={{
          whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            overflowWrap: "break-word",
          padding: "15px",
          backgroundColor: "#ECE5DD",
          minHeight: "450px",
        }}
      >
        <div
          className="message-bubble"
          style={{
            backgroundColor: "#DCF8C6",
            borderRadius: "10px",
            padding: "5px",
            marginBottom: "10px",
            maxWidth: "80%",
            fontSize: "14px",
            color: "#000",
            whiteSpace: "pre-wrap",
            boxShadow: "0 1px 1px rgba(0, 0, 0, 0.2)",
            textTransform: "capitalize",
            direction, // Apply detected direction
            textAlign: direction === "rtl" ? "right" : "left",
          }}
          dangerouslySetInnerHTML={{
            __html: content || translate("defaultContent"),
          }}
        />
        {attachment && attachment.type.startsWith("image/") && (
          <div className="attachment-preview">
            <img
              src={attachment.url}
              alt={translate("attachmentAlt")}
              style={{
                maxWidth: "80%",
                borderRadius: "10px",
                marginTop: "10px",
                boxShadow: "0 1px 1px rgba(0, 0, 0, 0.2)",
              }}
            />
          </div>
        )}
        {attachment && attachment.type === "application/pdf" && (
          <div
            className="pdf-preview"
            style={{
              marginTop: "10px",
              padding: "10px",
              border: "1px solid #ddd",
              borderRadius: "5px",
              backgroundColor: "#fff",
              textAlign: "center",
            }}
          >
            <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
              {translate("pdfAttachmentLabel")}: {attachment.name}
            </p>
          </div>
        )}
      </div>

      {/* Footer */}
      <div
        className="whatsapp-footer d-flex justify-content-between align-items-center"
        style={{
          backgroundColor: "#075E54",
          padding: "10px",
          color: "#fff",
          borderTop: "1px solid #ddd",
        }}
      >
        <button
          className="btn"
          style={{
            color: "#fff",
            fontSize: "20px",
            padding: "5px 8px",
          }}
        >
          <FaPaperclip />
        </button>
        <div
          className="typing-field d-flex align-items-center bg-white"
          style={{
            width: "100%",
            borderRadius: "20px",
            padding: "5px 10px",
            marginLeft: "10px",
          }}
        >
          <input
            type="text"
            placeholder={translate("typeMessagePlaceholder")}
            style={{
              border: "none",
              outline: "none",
              flex: "1",
              padding: "5px",
              fontSize: "14px",
              direction: "ltr", // Typing field is always LTR
            }}
          />
          <button
            className="btn"
            style={{
              backgroundColor: "#25D366",
              color: "#fff",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "0px",
            }}
          >
            <FaPaperPlane />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsappScreen;
